"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportWebPageShare = void 0;
const extraction_1 = require("./extraction");
const reporting_1 = require("./reporting");
const types_1 = require("./types");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const web_sentry_1 = require("@snapchat/web-sentry");
const web_env_1 = require("@snapchat/web-env");
const serverReportingEndpointSuffix = "/web-page-share";
function buildWebPageShareEvent({ sessionTimeSec, shareSource, webDestinationsAvailable, webDestinationsSeen, destinationSelected, shareStatus, deepLinkUrl = "", webPageUrl = "", pageType, webClientId = "", }) {
    if (!webClientId) {
        if ((0, web_env_1.isRunningOnDevEnv)()) {
            console.error("Missing params for WebPageShare event");
        }
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: `BlizzardEvents.WebPageShare.MissingParams.${types_1.PageType[pageType]}`,
                value: 1,
            });
        }
        (0, web_sentry_1.logSentryError)("Missing params for WebPageShare Blizzard Event");
        return;
    }
    return {
        webServerEventBase: (0, extraction_1.extractWebServerEventBase)(pageType, webClientId),
        sessionTimeSec: sessionTimeSec.toString(),
        shareSource,
        webDestinationsAvailable,
        webDestinationsSeen,
        destinationSelected,
        shareStatus,
        deepLinkUrl,
        webPageUrl,
    };
}
function reportWebPageShare(params) {
    const webPageShareEvent = buildWebPageShareEvent(params);
    if (webPageShareEvent) {
        (0, reporting_1.reportServerEvent)(serverReportingEndpointSuffix, webPageShareEvent);
    }
}
exports.reportWebPageShare = reportWebPageShare;
//# sourceMappingURL=WebPageShare.js.map